import { render, staticRenderFns } from "./TasksCalendar.vue?vue&type=template&id=06a73f79"
import script from "./TasksCalendar.vue?vue&type=script&lang=js"
export * from "./TasksCalendar.vue?vue&type=script&lang=js"
import style0 from "./TasksCalendar.vue?vue&type=style&index=0&id=06a73f79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports